export default __webpack_public_path__ + "static/media/battery.e7ea9bf8.png";